// pothos manager «Обзор» v2 (хэндофф 2026-07-19) — /api/getManagerOverviewBoard.
// Всё из каталога pothos_assets. С 2026-08-31 (правило Глеба со звонка):
// ready/potential = ТОЛЬКО то, что реально уйдёт в zip прямо сейчас
// (SHIP_READY_SQL ↔ ShipmentReadyRowSchema — те же диалекты, какими судит
// сборка архива); «дойдёт» = status qa, in_flight = uploaded/in_work.
// finalize — очередь крона finalizePackaging (принято QA, ждёт PID/IMG):
// отдельная цифра «Ждёт финализации N · ~X мин», в потенциал не входит.
// plan_remaining = остаток плана locale_limits минус отгруженное каталога
// (недельного плана в данных нет — «из N плана» это остаток общего плана).
// Матрица «Текущая отгрузка» = ГОТОВЫЕ строки по странам × (категория × вид) —
// сумма матрицы обязана сходиться со счётчиком (гейт no_locale).
import { z } from 'zod';
import { PothosShipReadinessSchema } from './manager-assets';
import { AssetSourceGroupSchema } from '../vocab/catalog';

export const PothosOverviewCatSchema = z.object({
  key: z.enum(['member', 'event', 'coupon', 'gift']),
  ready: z.number(),
  qa: z.number(),
  target: z.number(),
});

// Плашки «Готово к отгрузке» по ИСТОЧНИКУ материала (Пользователи /
// Скреппинг / Размножение — вместо прежнего среза по отделам it/upwork/…).
// Карта пайплайн → источник: SOURCE_GROUP_BY_PIPELINE (vocab/catalog.ts).
export const PothosOverviewSourceReadySchema = z.object({
  key: AssetSourceGroupSchema,
  ready: z.number(),
});

export const PothosOverviewMatrixRowSchema = z.object({
  country_iso: z.string(),
  country: z.string(),
  priority: z.string(),
  cells: z.object({
    ticket_s: z.number(), ticket_p: z.number(),
    gift_s: z.number(), gift_p: z.number(),
    member_s: z.number(), member_p: z.number(),
    coupon_s: z.number(), coupon_p: z.number(),
  }),
});
export type PothosOverviewMatrixRow = z.infer<typeof PothosOverviewMatrixRowSchema>;

export const PothosManagerOverviewBoardResSchema = z.object({
  hero: z.object({
    ready: z.number(),
    qa: z.number(),
    in_flight: z.number(),
    potential: z.number(),
    plan_remaining: z.number(),
    cats: z.array(PothosOverviewCatSchema),
  }),
  ship_sources: z.array(PothosOverviewSourceReadySchema),
  matrix: z.array(PothosOverviewMatrixRowSchema),
  // Сколько из `accepted` реально уйдёт в архив, и что держит остальное.
  // Считается на сервере тем же правилом, каким сборка судит строку в браузере
  // (`SHIP_READY_SQL` ↔ `ShipmentReadyRowSchema`).
  ship_ready: PothosShipReadinessSchema,
  // Очередь финализации: принято QA, ждёт крона упаковки (PID/IMG).
  // eta_minutes = ceil(waiting / произв. крона за проход) × период прохода.
  finalize: z.object({
    waiting: z.number(),
    eta_minutes: z.number(),
  }),
});
export type PothosManagerOverviewBoardRes = z.infer<typeof PothosManagerOverviewBoardResSchema>;
